// extracted by mini-css-extract-plugin
export default {"acordeon":"AcordeonFiltros_acordeon__v5xDq"};